import {
  ACTION_ARGS,
  Arg,
  CONTAINER_ARGS,
  INPUT_FORM_ARGS,
  Metadata,
  pick,
} from '../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import FlexRow from '../layout/flex/row.gjs';
import Super from './base.gjs';
import styles from './label.module.scss';

const METADATA = Metadata.define({
  description: 'SPDS-compliant label component',
  extends: [
    pick(ACTION_ARGS, [
      {
        name: 'onClick',
        description: 'Action to be called when the label is clicked',
      },
    ]),
    pick(CONTAINER_ARGS, [{ name: 'tag', defaultValue: 'label' }]),
    pick(INPUT_FORM_ARGS, [
      {
        name: 'required',
        description: 'Indicates whether the associated field is required',
      },
    ]),
  ],
  meta: {
    for: Arg.string({ description: 'The ID of the form element this label is associated with' }),
    label: Arg.string({ description: 'The label text to display' }).initial('Label'),
    srOnly: Arg.boolean({
      description: 'Visually hides the label while keeping it accessible to screen readers',
    }),
  },
  name: 'Label',
});

export default class SpdsCoreLabel extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  classesToMapToArgs = ['srOnly', 'required'];
  baseClass = 'spds-label';
  styles = styles;

  get gap() {
    return this.args.required ? '2px' : '0';
  }

  get tag() {
    return this.argOrDefault('tag');
  }

  handleClick = evt => {
    if (!this.args.onClick) return;

    evt.preventDefault();

    this.args.onClick();
  };

  <template>
    <FlexRow
      @content={{@label}}
      @gap={{this.gap}}
      @tag={{this.tag}}
      class={{this.classes}}
      data-test-spds-label={{this.componentName}}
      id={{this.id}}
      for={{@for}}
      {{this.validateArguments}}
      {{on "click" this.handleClick}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const SPDS_CORE_LABEL_METADATA = SpdsCoreLabel.metadata;
